import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CouponProvider } from './context/CouponContext';
import { CartProvider } from './context/CartContext';
import { CookieConsentProvider } from './context/CookieConsentContext';
import { OrderProvider } from './context/OrderContext';
import { ProductProvider } from './context/ProductContext';
import { BlogProvider } from './context/BlogContext';
import ScrollToTop from './components/ScrollToTop';
import GoogleAnalytics from './components/GoogleAnalytics';
import { SeoProvider } from './components/Seo';
import Layout from './components/Layout';
import AdminLayout from './components/admin/AdminLayout';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import ProductLegacyRedirect from './pages/ProductLegacyRedirect';
import PreOrder from './pages/PreOrder';
import PreOrders from './pages/PreOrders';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import CheckoutResult from './pages/CheckoutResult';
import Orders from './pages/Orders';
import Addresses from './pages/Addresses';
import Profile from './pages/Profile';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import VerifyEmailPending from './pages/VerifyEmailPending';
import Login from './pages/Login';
import Register from './pages/Register';
import CookiePolicy from './pages/CookiePolicy';
import LegalDocumentPage from './pages/LegalDocumentPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProducts from './pages/admin/AdminProducts';
import AdminProductForm from './pages/admin/AdminProductForm';
import AdminOrders from './pages/admin/AdminOrders';
import AdminOrderRequests from './pages/admin/AdminOrderRequests';
import AdminPreOrders from './pages/admin/AdminPreOrders';
import AdminBlogPosts from './pages/admin/AdminBlogPosts';
import AdminBlogPostForm from './pages/admin/AdminBlogPostForm';
import Blog from './pages/Blog';
import BlogPostDetail from './pages/BlogPostDetail';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <AuthProvider>
      <ProductProvider>
        <BlogProvider>
        <OrderProvider>
          <CouponProvider>
          <CartProvider>
            <CookieConsentProvider>
            <BrowserRouter>
              <SeoProvider>
              <ScrollToTop />
              <GoogleAnalytics />
              <Routes>
                <Route element={<Layout />}>
                  <Route index element={<Home />} />
                  <Route path="shop" element={<Shop />} />
                  <Route path="blog" element={<Blog />} />
                  <Route path="blog/:slug" element={<BlogPostDetail />} />
                  <Route path="urun/:slug" element={<ProductDetail />} />
                  <Route path="product/:legacy" element={<ProductLegacyRedirect />} />
                  <Route
                    path="on-siparis/:slug"
                    element={
                      <ProtectedRoute>
                        <PreOrder />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="cart" element={<Cart />} />
                  <Route
                    path="checkout"
                    element={
                      <ProtectedRoute>
                        <Checkout />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="checkout/result"
                    element={
                      <ProtectedRoute>
                        <CheckoutResult />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="orders"
                    element={
                      <ProtectedRoute>
                        <Orders />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="addresses"
                    element={
                      <ProtectedRoute>
                        <Addresses />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="profile"
                    element={
                      <ProtectedRoute>
                        <Profile />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="pre-orders"
                    element={
                      <ProtectedRoute>
                        <PreOrders />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="login" element={<Login />} />
                  <Route path="register" element={<Register />} />
                  <Route path="auth/verify-email" element={<VerifyEmail />} />
                  <Route path="auth/verify-email-pending" element={<VerifyEmailPending />} />
                  <Route path="auth/forgot-password" element={<ForgotPassword />} />
                  <Route path="auth/reset-password" element={<ResetPassword />} />
                  <Route path="cerez-politikasi" element={<CookiePolicy />} />
                  <Route path="yasal/:slug" element={<LegalDocumentPage />} />
                  <Route path="*" element={<NotFound />} />
                </Route>

                <Route
                  path="admin"
                  element={
                    <AdminRoute>
                      <AdminLayout />
                    </AdminRoute>
                  }
                >
                  <Route index element={<AdminDashboard />} />
                  <Route path="products" element={<AdminProducts />} />
                  <Route path="products/new" element={<AdminProductForm />} />
                  <Route path="products/:id/edit" element={<AdminProductForm />} />
                  <Route path="orders" element={<AdminOrders />} />
                  <Route path="order-requests" element={<AdminOrderRequests />} />
                  <Route path="pre-orders" element={<AdminPreOrders />} />
                  <Route path="blog" element={<AdminBlogPosts />} />
                  <Route path="blog/new" element={<AdminBlogPostForm />} />
                  <Route path="blog/:id/edit" element={<AdminBlogPostForm />} />
                  <Route path="*" element={<NotFound />} />
                </Route>
              </Routes>
              </SeoProvider>
            </BrowserRouter>
            </CookieConsentProvider>
          </CartProvider>
          </CouponProvider>
        </OrderProvider>
        </BlogProvider>
      </ProductProvider>
    </AuthProvider>
  );
}
